import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import ClassInterface from "../class_interface/ClassInterface";
import Button from "../../components/Button";
import ExitButton from "../../components/ExitButton";
import authFetch from "../../api/authFetch";

const SelectClass = ({successHandler}) => {
    const {auth, setAuth} = useAuth();
    const [classes, setClasses] = useState([]);
    const [course, setCourse] = useState("");

    const getClasses = async () => {
        const response = await authFetch(`/users/classes`, { method: "GET" });
        if (response.ok) {
            const json = await response.json();
            setClasses(json);
        }
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
    }

    useEffect(() => {getClasses()}, [course]);

    if (course !== "") {
        return <ClassInterface successHandler={(state) => setCourse(state)} course={course}/>
    }

    return <main className="page-shell">
        <div className="page-container max-w-3xl">
        <div className="mb-8 flex items-center gap-4">
            <ExitButton func={()=> {successHandler(false)}} />
            <div>
                <p className="panel-heading">Learning spaces</p>
                <h1 className="page-heading">Select a class</h1>
            </div>
        </div>
        <div className="panel flex flex-col gap-3 p-5">
                {classes.map(className => {
                    return <Button
                        key={className}
                        text={className}
                        func={() => setCourse(className)}
                        variant="secondary"
                        className="w-full justify-between !text-left"
                    />
                })}
                {classes.length === 0 && <div className="empty-state">You have not joined any classes yet.</div>}
        </div>
        </div>
    </main>
}

export default SelectClass;
